export default __webpack_public_path__ + "static/media/close_icon.2dfeb8fc.svg";